import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import styles from './List.module.less';
import { ListSpacingContext } from './Li';
export var List = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      component = _ref.component,
      _ref$ordered = _ref.ordered,
      ordered = _ref$ordered === void 0 ? false : _ref$ordered,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "component", "ordered", "spacing"]);

  var Component = component || (ordered ? 'ol' : 'ul');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classNames(className, styles.list, Component === 'ol' && styles['list--ordered'], Component === 'ul' && styles['list--unordered']) // @ts-expect-error -- type error is caused by the fact that we don't know
    // statically if this component will use `<ul>` or `<ol>`, so the ref
    // doesn't have the correct type.
    ,
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(ListSpacingContext.Provider, {
    value: spacing
  }, children));
});
List.displayName = 'List';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');

  List.propTypes = {
    /** Creates a ordered, numbered list. */
    ordered: PropTypes.bool,

    /** Controls spacing between list elements (NDS value) */
    spacing: PropTypes.oneOfType([PropTypes.oneOf([0, 1, 2, 3, 4, 5]), PropTypes.oneOf(['0', '1', '2', '3', '3-half', '4', '5'])]),

    /**
     * Allows you to provide a React component or other HTML element,
     * overriding the default `ul` and `ol` options.
     */
    component: PropTypes.elementType,

    /** Children inside the <ul> or <ol>. Should be <Li> elements. */
    children: PropTypes.node,
    className: PropTypes.string
  };
}